import { Box, Checkbox, Flex, TooltipPopper, useTooltip } from '@modusign/design-system';
import { ChangeEventHandler, useState } from 'react';

import { LabelingState } from '@app/features/label/components/LabelPopovers/context/types';

const indeterminateCheckboxLoop = ['SOME', 'ALL', 'NONE'] as LabelingState[];
const booleanCheckboxLoop = ['ALL', 'NONE'] as LabelingState[];

interface LabelListItemCheckboxProps {
  children: React.ReactNode;
  checked: LabelingState;
  disableMessage: string | false;
  onCheck: (checked: LabelingState) => void;
}

function LabelCheckListItem({
  children,
  checked,
  disableMessage,
  onCheck,
}: LabelListItemCheckboxProps) {
  const [labelCheckStateLoop] = useState(
    checked === 'SOME' ? indeterminateCheckboxLoop : booleanCheckboxLoop
  );

  const onChange: ChangeEventHandler<HTMLInputElement> = () => {
    onCheck(
      labelCheckStateLoop[(labelCheckStateLoop.indexOf(checked) + 1) % labelCheckStateLoop.length]
    );
  };

  const {
    activated,
    popperId,
    popperRef,
    getPopperProps,
    triggerRef,
    getTriggerProps,
    position,
    top,
    left,
  } = useTooltip({ disabled: !disableMessage, placement: 'top-start' });

  return (
    <Flex
      alignItems="center"
      as="label"
      flex="auto"
      gap="9px"
      height="30px"
      sx={{
        cursor: 'pointer',
      }}
    >
      {activated && (
        <TooltipPopper
          id={popperId}
          mode="night"
          placement="top-start"
          ref={popperRef}
          scale="md"
          {...getPopperProps()}
          sx={{ position, top, left: left - 9 }}
        >
          {disableMessage}
        </TooltipPopper>
      )}
      <Box flex="none" ref={triggerRef} {...getTriggerProps()}>
        <Checkbox
          checked={checked !== 'NONE'}
          disabled={!!disableMessage}
          indeterminate={checked === 'SOME'}
          onChange={onChange}
        />
      </Box>
      {children}
    </Flex>
  );
}

export default LabelCheckListItem;
